import { remotingConstants } from '@lifesize/clients.remoting';
import { createAction } from '@lifesize/typescript-react-redux-utils';
import ActionTypes from 'constants/ActionTypes';

const actions = {
  createWirelessOffer: (payload: MediaStream) => createAction(remotingConstants.remoting.actions.WIRELESS_PRESENTATION_CREATE_OFFER, payload),
  dismissExtensionInstall: () => createAction(ActionTypes.EndExtensionInstall),
  goToStoreAndWaitForInstall: () => createAction(ActionTypes.WaitForExtensionInstall),
  installExtension: () => createAction(ActionTypes.InstallExtension),
  sendWirelessEnd: (payload?: any) => createAction(remotingConstants.remoting.actions.WIRELESS_PRESENTATION_SEND_END, payload),
  setPresentationError: (hasError: boolean) => createAction(ActionTypes.SetPresentationError, hasError),
  startPresenting: (data: MediaStream) => createAction(ActionTypes.StartPresenting, data),
  stopUnansweredPresentation: () => createAction(ActionTypes.StopUnansweredPresentation)
};

export default actions;



// WEBPACK FOOTER //
// ./src/actions/presentation.ts